var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSoS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "#5C61F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#5C61F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "url(#pattern0_10701_4681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10701_4681",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10701_4681",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10701_4681",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSoS);
export default __webpack_public_path__ + "static/media/Search_SoS.4009a231fbb015d4cf176d859b4115b3.svg";
export { ForwardRef as ReactComponent };